import RescheduleComponent from "./appointments/RescheduleComponent";
import { XMarkIcon } from "@heroicons/react/24/outline";

export default function RescheduleModal({
  isOpen,
  onClose,
  appointmentId,
  handleReschedule,
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-4">
        {/* Backdrop */}
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
          onClick={onClose}
        />
        
        {/* Modal Content */}
        <div className="relative w-full max-w-6xl bg-white rounded-sm shadow-xl">
          {/* Close Button */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 z-10 p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-sm transition-colors"
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
          
          {/* Reschedule Component */}
          <RescheduleComponent
            appointmentId={appointmentId}
            onReschedule={handleReschedule}
            onClose={onClose}
            clientView={false}
          />
        </div>
      </div>
    </div>
  );
}
